import "../AuthStyle.css";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContextProvider";
import {
  forgotPassword,
  resetPassword,
  verifyForgotOtp,
} from "../../../network/network";
import { Form, Input, Button, Col, Row, Dropdown, Spin } from "antd";

import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { DownOutlined } from "@ant-design/icons";
import { handleApiError } from "../../../utils/errorHandler";
import { showSuccessMessage } from "../../../utils/antdMessage";
import AccountChooser from "../../../components/AccountChooser/AccountChooser";
import { UserType } from "../../../configs/constants";
import {
  PORTAL_LANGUAGES,
  buildPortalAppConfig,
  portalLanguageLabel,
  resolvePortalLanguage,
} from "../../../utils/portalLanguage";

const Forgot = () => {
  const { appConfig, setAppConfigWrapper } = useContext(AppContext);
  const [OTPFormVisible, setOTPFormVisible] = useState(false);
  const [resetFormVisible, setResetFormVisible] = useState(false);
  const [token, setToken] = useState(false);
  const [loading, setloading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [companyId, setCompanyId] = useState(null);

  const [forgotForm] = Form.useForm();
  const { t } = useTranslation();
  let navigate = useNavigate();

  const handleForgotValidation = async () => {
    try {
      setloading(true);

      const values = await forgotForm.validateFields();
      const response = await forgotPassword(values);

      if (response?.data?.success) {
        setOTPFormVisible(true);
        showSuccessMessage(t("otp_sent_successfully"));
        return;
      }

      if (response?.data?.success === false) {
        handleApiError(response, t);
      }
    } catch (error) {
      handleApiError(error, t);
    } finally {
      setloading(false);
    }
  };

  const onOTPFormFinish = async (otpValues) => {
    try {
      setloading(true);

      const values = await forgotForm.validateFields();

      const response = await verifyForgotOtp({
        ...otpValues,
        ...values,
      });

      if (response?.data?.success) {
        const responseAccounts =
          response?.data?.data?.accounts || response?.data?.accounts || [];
        const merchantAccounts = responseAccounts.filter(
          (account) =>
            account.company_id != null &&
            (Number(account.type) === UserType.BusinessOwner ||
              Number(account.type) === UserType.Employee),
        );

        setToken(response.data.token || response?.data?.data?.token);

        if (merchantAccounts.length === 0) {
          handleApiError({}, t);
          return;
        }

        if (merchantAccounts.length > 1) {
          setAccounts(merchantAccounts);
          setOTPFormVisible(false);
        } else {
          setCompanyId(merchantAccounts[0].company_id);
          setResetFormVisible(true);
        }

        showSuccessMessage(t("otp_verified"));
        return;
      }

      if (response?.data?.success === false) {
        handleApiError(response, t);
      }
    } catch (error) {
      handleApiError(error, t);
    } finally {
      setloading(false);
    }
  };

  const onResetPassword = async (resetPassValues) => {
    try {
      setloading(true);

      const values = await forgotForm.validateFields();

      const response = await resetPassword({
        ...resetPassValues,
        ...values,
        token,
        ...(companyId != null ? { company_id: companyId } : {}),
      });

      if (response?.data?.success) {
        showSuccessMessage(t("reset_password_successfully"));
        navigate("/login");
        return;
      }

      if (response?.data?.success === false) {
        handleApiError(response, t);
      }
    } catch (error) {
      handleApiError(error, t);
    } finally {
      setloading(false);
    }
  };

  const LangOptions = PORTAL_LANGUAGES.map(({ code, label }) => ({
    key: code,
    label: (
      <div onClick={() => setAppConfigWrapper(buildPortalAppConfig(appConfig, code))}>
        {label}
      </div>
    ),
  }));

  return (
    <>
      <div
        style={{
          backgroundImage: "url('/images/bg-img.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          boxShadow: "inset 0 0 0 2000px var(--color-shadow-soft)",
          minHeight: "100vh",
          direction: appConfig.direction
            ? appConfig.direction === "ltr"
              ? "ltr"
              : "rtl"
            : "ltr",
        }}
      >
        <div className="main-wrapper">
          <header className="header">
            <div className="app-flex-between">
              <div className="app-flex">
                <a
                  href="https://anypos.ai/"
                  target="_blank"
                  rel="noreferrer"
                  className="app-flex"
                >
                  <img
                    src="/anypos-logo.svg"
                    alt="anypos"
                    className="main_logo"
                  />
                </a>
              </div>
              <div className="Button-area app-flex-align-center-gap-10">
                <a href="https://anypos.ai/" target="_blank" rel="noreferrer">
                  <Button type="default" className="md_down_display_none">
                    {t("visit_website")}
                  </Button>
                </a>

                <Link to="/login">
                  <Button type="primary">{t("login")}</Button>
                </Link>

                <Dropdown
                  trigger={["click"]}
                  menu={{
                    items: LangOptions,
                  }}
                  className="md_down_display_none"
                >
                  <Button type="default">
                    {portalLanguageLabel(resolvePortalLanguage(appConfig))}
                    <span
                      style={{
                        margin: appConfig.direction
                          ? appConfig.direction === "ltr"
                            ? "0 0 0 8px"
                            : "0 8px 0 0"
                          : "0 0 0 8px",
                      }}
                    >
                      <DownOutlined className="app-text-xs" />
                    </span>
                  </Button>
                </Dropdown>
                <Dropdown
                  trigger={["click"]}
                  menu={{
                    items: LangOptions,
                  }}
                  className="md_up_display_none"
                >
                  <img
                    src="/icons/globe.png"
                    alt="language"
                    style={{
                      width: "fit-content",
                      height: "fit-content",
                      backgroundColor: "var(--color-primary)",
                      borderRadius: "5px",
                      padding: "2px",
                    }}
                  />
                </Dropdown>
              </div>
            </div>
          </header>
          <div className="auth_area">
            <Row>
              <Col xs={24} sm={3} md={4} lg={6} xl={7} xxl={8}></Col>
              <Col xs={24} sm={18} md={16} lg={12} xl={10} xxl={8}>
                <Spin spinning={loading}>
                  <div
                    style={{
                      backgroundColor: "var(--color-white-soft)",
                      padding: "20px",
                      boxShadow: "0px 0px 10px var(--color-overlay)",
                      borderRadius: "20px",
                    }}
                  >
                    <Form
                      name="forgot-user-form"
                      layout="vertical"
                      onFinish={handleForgotValidation}
                      form={forgotForm}
                      style={{
                        display:
                          !OTPFormVisible &&
                          !resetFormVisible &&
                          accounts.length === 0
                            ? "block"
                            : "none",
                      }}
                    >
                      <div className="app-auth-form-footer">
                        <h2>{t("forgot")}</h2>
                      </div>
                      <Form.Item
                        name="phone"
                        label={t("phone_number") + " eg: +966 5xxxxxxx"}
                        rules={[
                          {
                            required: true,
                            message: t("validate_phone_required"),
                          },
                          {
                            min: 12,
                            message: t("validate_phone_exact_limit"),
                          },
                          {
                            max: 12,
                            message: t("validate_phone_exact_limit"),
                          },
                        ]}
                      >
                        <PhoneInput
                          localization={["sa"]}
                          country={"sa"}
                          onlyCountries={["sa"]}
                          masks={{ sa: "(...) ..-..-.." }}
                          placeholder="+966 (123) 45-67-89"
                          style={{
                            direction: "ltr",
                          }}
                        />
                      </Form.Item>
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                          margin: "20px 0 10px 0",
                        }}
                      >
                        <Button type="primary" htmlType="submit">
                          {t("send_otp")}
                        </Button>
                      </div>
                    </Form>

                    <Form
                      name="validate-otp-form"
                      layout="vertical"
                      onFinish={onOTPFormFinish}
                      style={{
                        display:
                          OTPFormVisible &&
                          !resetFormVisible &&
                          accounts.length === 0
                            ? "block"
                            : "none",
                      }}
                    >
                      <div className="app-auth-form-footer">
                        <h2>{t("verify_otp")}</h2>
                      </div>
                      <p>
                        {t("opt_message")}
                        <br />
                        {t("if_you_want_to_change_phone_number")}{" "}
                        <Link to="#" onClick={() => setOTPFormVisible(false)}>
                          {t("click_here")}
                        </Link>
                      </p>
                      <Form.Item
                        name="otp"
                        label={t("otp")}
                        rules={[
                          {
                            required: true,
                          },
                          {
                            max: 6,
                          },
                          {
                            min: 6,
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password
                          type="number"
                          minLength={6}
                          maxLength={6}
                          size="large"
                        />
                      </Form.Item>
                      <div
                        style={{
                          width: "100%",
                          margin: "20px 0 10px 0",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          type="default"
                          onClick={() => setOTPFormVisible(false)}
                        >
                          {t("back")}
                        </Button>
                        <Button type="primary" htmlType="submit">
                          {t("validate")}
                        </Button>
                      </div>
                    </Form>

                    {accounts.length > 1 && !resetFormVisible ? (
                      <AccountChooser
                        accounts={accounts}
                        loading={loading}
                        onSelect={(account) => {
                          setCompanyId(account.company_id);
                          setAccounts([]);
                          setResetFormVisible(true);
                        }}
                      />
                    ) : null}

                    <Form
                      name="reset-pass-form"
                      layout="vertical"
                      onFinish={onResetPassword}
                      style={{
                        display: resetFormVisible ? "block" : "none",
                      }}
                    >
                      <div className="app-auth-form-footer">
                        <h2>{t("reset_password")}</h2>
                      </div>
                      <Form.Item
                        name="password"
                        label={t("password")}
                        rules={[
                          {
                            required: true,
                            message: t("validate_password_required"),
                          },
                          {
                            min: 6,
                            message: t("validate_password_min_characters"),
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password size="large" />
                      </Form.Item>
                      <Form.Item
                        name="password_confirmation"
                        label={t("confirm_password")}
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: t("validate_password_confirm_not_matched"),
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }

                              return Promise.reject(
                                new Error(
                                  t("validate_password_confirm_not_matched"),
                                ),
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password size="large" />
                      </Form.Item>
                      <div
                        style={{
                          width: "100%",
                          margin: "20px 0 10px 0",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button type="primary" htmlType="submit">
                          {t("reset")}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Spin>
              </Col>
              <Col xs={24} sm={3} md={4} lg={6} xl={7} xxl={8}></Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
